import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class BillboardService {
	constructor(private http: HttpClient) {}

	getBillboardData(eventId = 'jki30th') {
		return this.http.get(
			`/api/v1/events/${eventId}/billboard`
		);
	}
}
